(function () {
    "use strict";

    angular
        .module("app")
        .directive("colorTypeAhead", ["PrototypeService", colorTypeAhead]);

    function colorTypeAhead(prototypeService) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (searchText) {
                    return prototypeService.getColors(searchText).then(function (response) {
                        if (response) {
                            angular.forEach(response, function (item) {
                                item.DisplayText = item.ColorName + " (" + item.ColorKey + ")";
                            });
                            return response;
                        }
                        return [];
                    });
                };

                scope.setValue = function (item) {
                    scope.selectedValue = item.ColorKey;
                };

                scope.onBlur = function () {
                    if (!scope.selectedText)
                        scope.selectedValue = null;
                };

            },
            scope: { selectedText: "=", selectedValue: "="},
            template: '<input' +
                ' uib-typeahead="item.DisplayText for item in search($viewValue)"' +
                ' ng-blur="onBlur()"' +
                ' ng-model="selectedText"' +
                ' typeahead-on-select="setValue($item)"' +
                ' class= "form-control"' +
                ' aria-autocomplete="list"' +
                ' autocomplete="off"' +
                ' type="text"/><i class="fa fa-i-cursor edit-cursor" aria-hidden="true"></i>'
        };
    }
})();

